import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {getAuth} from "firebase/auth";
import { getStorage} from "firebase/storage";


const firebaseConfig = {
    apiKey: "AIzaSyCYwzwL8KQIaBM3Y3ajZ6Q4hJqSY_JoXJU",
    authDomain: "miladetallesweb.firebaseapp.com",
    projectId: "miladetallesweb",
    storageBucket: "miladetallesweb.appspot.com",
    messagingSenderId: "234899894139",
    appId: "1:234899894139:web:bfd95f773d7b747d6ed7de",
    measurementId: "G-FNG1WRLP07"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export {auth,db,storage}; 
